<template src="./template.html"></template>

<script>
  import fetchMaster from 'fetchMasterLp1';
  import suggest from 'suggest';
  import _ from 'lodash';

  export default {
    name: 'v-form-fetch-suggest-select',

    mixins: [
      fetchMaster,
      suggest,
    ],

    props: {
      isValidate: {
        type: [Boolean, String, Array],
        default: true,
      },
      refBindClass: {
        type: Object,
        required: false,
      },
      refClass: {
        type: String,
        required: false,
      },
      refDefault: {
        type: null,
        default: '',
      },
      refInitialText: {
        type: String,
      },
      refItemClass: {
        type: String,
        required: false,
      },
      refItemLabelKey: {
        type: String,
        default: 'name',
      },
      refItemValueKey: {
        type: String,
        default: 'id',
      },
      refMaster: {
        type: String,
        default: '',
      },
      refObserveKey: {
        type: [String, Array],
        default: '',
      },
    },

    data() {
      return {
        validate: this.isValidate,
        initialMaster: [],
        fetchedMaster: [],
      };
    },

    computed: {
      key() {
        this.setQuery('');
        return _.get(this.optionsData, `[0].${this.refItemValueKey}`, 0);
      },

      optionsData() {
        return this.master;
      },

      formValue: {
        get() {
          const value = this.$store.getters.getValueByKey(this.refName);
          return (_.isUndefined(value) || _.isNull(value)) ? '' : value;
        },
        set(value) {
          const data = {[this.refName]: value};
          this.$store.dispatch('update', {data, isValidate: this.validate, path: this.formUrl});
        },
      },

      hasObserveValue() {
        if (Array.isArray(this.refObserveKey)) {
          let hasValue = false;
          _.each(this.refObserveKey, (key) => {
            const observeValue = this.$store.getters.getValueByKey(key);
            if (!_.isNull(observeValue) && !_.isUndefined(observeValue) && observeValue !== '') {
              hasValue = true;
            }
          });
          return hasValue;
        }

        const observeValue = this.$store.getters.getValueByKey(this.refObserveKey);
        return !_.isNull(observeValue) && !_.isUndefined(observeValue) && observeValue !== '';
      },

      disabled() {
        return this.isDisabled || this.refDisabled || _.isEmpty(this.fetchedMaster);
      },

      master() {
        return this.initialMaster.concat(this.fetchedMaster);
      },

      formUrl() {
        return this.refFormUrl;
      },
    },

    mounted() {
      this.$root.$on(this.refId, (value) => {
        this.setQuery(value);
      });

      if (!_.isNull(this.refDefault) && !_.isUndefined(this.refDefault)) {
        this.validate = false;
        const currentValue = this.$store.getters.getValueByKey(this.refName);

        if (_.isUndefined(currentValue)) {
          this.$store.commit('setValue', {[this.refName]: this.refDefault});
        }

        this.formValue = this.refDefault;
      }

      // 他のフィールドの値の変更によってselectのmasterが変わる場合、そのフィールドを監視して、
      // 変更があったらmasterを更新する。
      if (this.hasObserveValue) {
        this.fetchMaster(this.refMaster, this.refObserveKey).then((data) => {
          this.fetchedMaster = data;
        });
      }

      if (typeof this.refObserveKey === 'string') {
        this.setWatcher(this.refObserveKey);
      } else {
        _.each(this.refObserveKey, (key) => {
          this.setWatcher(key);
        });
      }
    },

    methods: {
      getItemValue(item) {
        return _.get(item, this.refItemValueKey, null);
      },
      getItemLabel(item) {
        return _.get(item, this.refItemLabelKey, null);
      },
    },
  };
</script>
